import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full px-4 lg:px-8 relative ',
);

export const ContentBox = w.div(
  'sm:flex items-center text-left w-full bg-[var(--azul)] rounded-xl text-white p-8 md:p-12 gap-16 lg:justify-between',
);

export const Title = w.h1(
  'text-4xl md:text-5xl xl:text-7xl'
)

export const SubTitle = w.p(
  'text-xl md:text-2xl xl:text-4xl mt-4 '
)

export const Image = w.img(
  'w-full sm:h-[332px] sm:min-h-[332px] sm:w-[498px] sm:min-w-[498px]  mt-10 md:mt-0 sm:-mr-[350px] md:-mr-[250px] lg:-mr-[120px]'
)

export const Form = w.form(
  'w-full flex flex-col gap-4 mt-10'
)

export const Input = w.input(
  'w-full rounded-full px-4 py-2 text-black focus:outline-none bg-transparent border placeholder:text-white'
)

export const Btn = w.button(
  'relative bg-white rounded-full text-[var(--azul)] font-bold px-12 py-3'
)

